export enum SubTabsEnum {
  Active,
  Inactive,
}
